import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Spinner, OverlayTrigger, Popover, Modal } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { Cart, CartPlus, PencilSquare, PlusSquare, LockFill, UnlockFill, ListUl } from 'react-bootstrap-icons';

class PartsModal extends ChemComponent {
	constructor(props) {
		super(props);

		// start with from date of 90 days ago
		var from90Days = new Date();
		from90Days.setDate(from90Days.getDate() - 90);
		
		var search = {
			SHOP_ID: null,
			PART_NAME: '',
			CATEGORY_ID: null,
			ALT_DESC: '',
			MANUF_NUM: '',
			X_REF: '',
			VENDOR_PART: '',
			PART_ID: '',
			VENDOR_NAME: null,
			DATE_MODIF_FROM: null,
			DATE_MODIF_TO: null,
			ORDER_BY: ['PART_NAME']
		};
		
		var partListInit = this.copyTable(partList);
		partListInit.query.search = this.constructSearch(search);
		partListInit.query.order = search.ORDER_BY;
		this.state = {
			search: search,
			partList: partListInit,
			showSearch: false,
			searchCount: null,
			part: null,
			partColumns: this.copyPartColumns(),
			dirty: false,
			editable: false,
			markUpRate: 1,
			renderKey: 0
		};
	}
	
	copyPartColumns(partId) {
		var initPartColumns = this.copyColumns(partColumns);
		// if this is a new part
		if (!partId) {
			// unit cost is calculated
			var unitCostIdx = this.findColumnByAccessor(initPartColumns, 'UNIT_COST');
			initPartColumns[unitCostIdx].editable = false;
		}
		return initPartColumns;
	}

	addPart() {
		var self = this;
		
		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Jobtrack/Search',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				entity: 'MARK_UP_RATE',
				search: { Operator: 'and', Children: [
					{ Attribute: 'SHOP_ID', Operator: '=', LongValue: 1 },
					{ Attribute: 'DELETE_FLAG', Operator: 'is null' },
					{ Attribute: 'VALID_FLAG', Operator: '=', StringValue: 'Y' }
				]},
				pageNumber: -1,
				pageSize: -1
			}
		}).done(function (data) {
			if (data.Success) {
				self.setState({
					part: self.copyObject(newPart),
					dirty: false,
					editable: true,
					partColumns: self.copyPartColumns(),
					markUpRate: data.Data[0].RATE_PCT,
					renderKey: self.state.renderKey + 1
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	loadPart(partId, editable) {
		var self = this;

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Jobtrack/Search',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				entity: 'PARTS_VW',
				search: { Attribute: 'PART_ID', Operator: '=', LongValue: partId },
				pageNumber: -1,
				pageSize: -1
			}
		}).done(function (data) {
			if (data.Success) {					
				self.mergeState({
					part: data.Data[0],
					partColumns: self.copyPartColumns(partId),
					dirty: false,
					editable: editable,
					renderKey: self.state.renderKey + 1
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});		
	}
	
	onChange(accessor, value) {
		var part = this.copyObject(this.state.part);
		this.setByAccessor(part, accessor, value);
		// if this is a new part and there is a vendor price
		if (!this.props.params.partId && !this.isEmpty(part.VENDOR_PRICE)) {
			// calculate unit cost
			this.setByAccessor(part, 'UNIT_COST', this.round(this.state.markUpRate*part.VENDOR_PRICE, 3));
		}
		this.mergeState({ part: part, dirty: true });
	}
	
	validatePart(event, columns, data) {
		return this.validate(columns, data);
	}

	onSubmit(event) {
		if (this.state.dirty) {
			var self = this;
			var part = this.copyObject(this.state.part);
			var url;
			
			// set ID sequence if this is a new part
			if (this.props.params.partId) {
				url = this.getConfig().host + '/Home/Update';
			} else {
				url = this.getConfig().host + '/Home/Insert';
				part.PART_ID = 'shop_part_seq.nextval';
			}

			this.ajax({
				type: 'post',
				url: url,
				overlay: true,
				data: {
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					entity: 'RECHARGES.SHOP_PART',
					data: part
				}
			}).done(function (data) {
				if (data.Success) {
					var partId = self.isNumeric(self.state.part.PART_ID) ? self.state.part.PART_ID : data.ID;
					self.props.onClose(['PART_ID', 'PART_NAME'], [partId, self.state.part.PART_NAME]);
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		} else {
			this.props.onClose(['PART_ID', 'PART_NAME'], [this.state.part.PART_ID, this.state.part.PART_NAME]);
		}
	}

	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search }, () => {
			if (accessor === 'PAGE_SEARCH') window.find(value);
		});
	}

	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: [{ Attribute: 'DELETE_FLAG', Operator: 'is null' }]
		};
		
		// maintain separate clause for part name since we will compare it to several different columns
		var pname_search = {
			Operator: 'or',
			Children: []
		};

		if (!this.isEmpty(data.SHOP_ID)) search.Children.push({ Attribute: 'SHOP_ID', Operator: '=', LongValue: data.SHOP_ID });
		if (!this.isEmpty(data.PART_NAME)) {
			// check if part_name starts with a number
			var partIDMatch = data.PART_NAME.match(/^([0-9]+)(?:\s|$)/);
			if (partIDMatch) {
				search.Children.push({ Attribute: 'PART_ID', Operator: '=', LongValue: partIDMatch[1] });
			} else {
				var like_pname = '%' + data.PART_NAME.toUpperCase() + '%';
				// compare all relevant text inputs to part name
				pname_search.Children.push({ Attribute: 'PART_NAME_UCASE', Operator: 'like', StringValue: like_pname });
				pname_search.Children.push({ Attribute: 'MANUF_NUM_UCASE', Operator: 'like', StringValue: like_pname });
				pname_search.Children.push({ Attribute: 'ALT_DESC_UCASE', Operator: 'like', StringValue: like_pname });
				pname_search.Children.push({ Attribute: 'VENDOR_PART_UCASE', Operator: 'like', StringValue: like_pname });
				pname_search.Children.push({ Attribute: 'X_REF_UCASE', Operator: 'like', StringValue: like_pname });
				search.Children.push(pname_search);
			}
		}
		if (!this.isEmpty(data.CATEGORY_ID)) search.Children.push({ Attribute: 'CATEGORY_ID', Operator: '=', LongValue: data.CATEGORY_ID });
		if (!this.isEmpty(data.ALT_DESC)) { 
			search.Children.push({ Attribute: 'ALT_DESC_UCASE', Operator: 'like', StringValue: '%' + data.ALT_DESC.toUpperCase() + '%' });
		}
		if (!this.isEmpty(data.MANUF_NUM)) {
			search.Children.push({ Attribute: 'MANUF_NUM_UCASE', Operator: 'like', StringValue: '%' + data.MANUF_NUM.toUpperCase() + '%' });
		}
		if (!this.isEmpty(data.X_REF)) {
			search.Children.push({ Attribute: 'X_REF_UCASE', Operator: 'like', StringValue: '%' + data.X_REF.toUpperCase() + '%' });
		}
		if (!this.isEmpty(data.VENDOR_PART)) {
			search.Children.push({ Attribute: 'VENDOR_PART_UCASE', Operator: 'like', StringValue: '%' + data.VENDOR_PART.toUpperCase() + '%' });
		}
		if (!this.isEmpty(data.VENDOR_NAME)) {
			search.Children.push({ Attribute: 'VENDOR_NAME_UCASE', Operator: 'like', StringValue: '%' + data.VENDOR_NAME.toUpperCase() + '%' });
		}
		if (!this.isEmpty(data.DATE_MODIF_FROM)) {
			search.Children.push({ Attribute: 'DATE_MODIF', Operator: '>=', DateValue: data.DATE_MODIF_FROM });
		}
		if (!this.isEmpty(data.DATE_MODIF_TO)) {
			// add 1 day
			var modifDateTo = this.getDate(data.DATE_MODIF_FROM);
			modifDateTo.setDate(modifDateTo.getDate() + 1);
			search.Children.push({ Attribute: 'DATE_MODIF', Operator: '<', DateValue: this.dateTimeToMVC(modifDateTo) });
		}

		return search;
	}
	
	onExpandSearch(event) {
		this.mergeState({
			showSearch: true,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();		
	}

	onSubmitSearch(event, newOrderBy) {
		// copy search in case we need to incorporate the new ordering
		var search = this.copyObject(this.state.search);
		var newPartList = this.copyTable(partList);
		newPartList.query.search = this.constructSearch(search);
		if (newOrderBy) {
			search.ORDER_BY = newOrderBy;
			newPartList.query.order = newOrderBy;
		}
		
		this.mergeState({
			search: search,
			partList: newPartList,
			showSearch: false,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
	}
	
	onSearchResult(data) {		
		this.mergeState({
			searchCount: data.ResultCount,
		});
	}
	
	renderCartColumn(part) {
		var self = this;
		
		return (<CartPlus style={{ cursor: 'pointer' }} onClick={() => {
			self.props.onClose(['PART_ID', 'PART_NAME'], [part.PART_ID, part.PART_NAME]);
		}} />);
	}
	
	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Parts',
			columns: exportColumns,
			entity: 'RECHARGES.PARTS_VW',
			search: this.constructSearch(this.state.search),
			order: this.state.search.ORDER_BY
		});

		var optionalBorderStyle = {
			marginBottom: 5
		};
		
		if (this.state.showSearch) {
			optionalBorderStyle.borderTop = '1px solid #eee';
			optionalBorderStyle.paddingTop = 10;
		};
		
		return (
		  <Modal size='xl' show={true} onHide={() => this.props.onClose()}>
			<Modal.Header closeButton>
			  {this.state.part ? <>
				  <Modal.Title>Material Part {this.state.part.PART_ID}</Modal.Title>&nbsp;&nbsp;
				  {this.state.editable ? 
					<UnlockFill style={{ cursor: 'pointer' }} onClick={() => this.mergeState({ editable: false })} /> : 
					<LockFill style={{ cursor: 'pointer' }} onClick={() => this.mergeState({ editable: true })} />}&nbsp;&nbsp;
				  <OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Return to Part Search</Popover.Header></Popover>}>
					<ListUl style={{ cursor: 'pointer' }} onClick={() => this.mergeState({ part: null, searchCount: null })} />
				  </OverlayTrigger>
				</> :
				<Modal.Title>Part Search</Modal.Title>
			  }
			</Modal.Header>

			<Modal.Body>
				<Container fluid>
				  <Row>
					<Col style={{ paddingTop: '10px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					  {this.state.part ?
						<ChemEdit parent={this} user={this.props.user} columns={this.state.partColumns} data={this.state.part}
						  onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
						  validate={(event, columns, data) => this.validatePart(event, columns, data)}
						  onSubmit={(event) => this.onSubmit(event)} editable={this.state.editable}>
						  <Form.Group as={Row}>
							<Col style={{ borderTop: '1px solid #eee', paddingTop: '5px', marginBottom: '10px' }}>
							  <Button id="select" variant="warning" type="submit" className="float-end">Select</Button>
							  <div className="float-end" style={{ fontStyle: 'italic', marginTop: '6px', marginRight: '10px' }}>{this.state.dirty ? "Changes will be saved" : "No changes"}</div>
							</Col>
						  </Form.Group>							
						</ChemEdit> :
						<Container fluid>	
						  <Row>
							<Col xs={12}>
							  {this.state.showSearch && <ChemEdit parent={this} user={this.props.user} columns={partSearch} data={this.state.search}
								renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />}
							</Col>
						  </Row>
						  <Form.Group as={Row} style={optionalBorderStyle}>
							<Col xs={3} style={{ marginTop: 8}}>
							  {this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
							</Col>
							<Col xs={1} style={{ marginTop: 6}}>
							  <form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
								  return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
								</OverlayTrigger>
							  </form>
							</Col>
							<Col xs={1} style={{ marginTop: 6}}>
							  <form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
								  return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
								</OverlayTrigger>
							  </form>
							</Col>
							<Col xs={7}>
							  {this.state.showSearch ?
								<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button> :
								<Button id="expand" variant="warning" type="button" className="float-end" onClick={(event) => this.onExpandSearch(event)}>Modify Search</Button>
							  }
							</Col>
						  </Form.Group>
						</Container>
					  }
					</Col>
				  </Row>
				  {!this.state.part && <Row>
					<Col>
					  <QueryTable renderKey={this.state.renderKey} parent={this} name='Jobtrack_Parts' table={this.state.partList}
						order={this.state.search.ORDER_BY} onTableSort={(newOrder) => this.onSubmitSearch(null, newOrder)}
						onResult={(data) => this.onSearchResult(data)} offsetHeight='150px' />
					</Col>
				  </Row>}
				</Container>
			</Modal.Body>
		  </Modal>
		);		
	}
}

const partSearch = [
	{ Header: 'Shop', accessor: 'SHOP_ID', type: 'select', row: 0, col: 0,
		options: { value: 'SHOP_ID', label: 'SHOP_NAME', entity: 'RECHARGES.PART_SHOP_SELECT_VW', order: 'SHOP_NAME' }},
	{ Header: 'Part Name', accessor: 'PART_NAME', row: 0, col: 1 },
	{ Header: 'Category/Keyword', accessor: 'CATEGORY_ID', row: 0, col: 2,
		options: { value: 'CATEGORY_ID', label: 'CATEGORY_NAME', entity: 'RECHARGES.PART_CATEGORY_SELECT_VW', order: 'CATEGORY_NAME_SORT' }},
	{ Header: 'Alt Desc', accessor: 'ALT_DESC', row: 1, col: 0 },
	{ Header: 'Manufacturer Number', accessor: 'MANUF_NUM', row: 1, col: 1 },
	{ Header: 'Cross Reference', accessor: 'X_REF', row: 1, col: 2 },
	{ Header: 'Vendor Part', accessor: 'VENDOR_PART', row: 2, col: 0 },
	{ Header: 'ID', accessor: 'PART_ID', row: 2, col: 1 },
	{ Header: 'Vendor Name', accessor: 'VENDOR_NAME', type: 'select', row: 2, col: 2,
		options: { value: 'VENDOR_NAME', label: 'VENDOR_NAME', entity: 'RECHARGES.SHOP_PART', distinct: true, order: 'VENDOR_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' },
				{ Attribute: 'VENDOR_NAME', Operator: 'is not null' }
	]}}},
	{ Header: 'Last Updated From', accessor: 'DATE_MODIF_FROM', type: 'date', row: 3, col: 0 },
	{ Header: 'Last Updated To', accessor: 'DATE_MODIF_TO', type: 'date', row: 3, col: 1 }
];

const partList = {
	query: { entity: 'RECHARGES.PARTS_VW', search: null, order: 'PART_NAME' },
	pageSize: 20,
	columns: [
		{ Header: props => <Cart />, accessor: 'cart', width: 25, sortable: false,
			Cell: props => props.parent.renderCartColumn(props.row.values) },
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addPart()} />, accessor: 'id', width: 25, 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.loadPart(props.row.values.PART_ID, true)} /> },
		{ Header: 'ID', accessor: 'PART_ID', width: 60,
			Cell: props => <HashLink onClick={() => props.parent.loadPart(props.value, false)}>{props.value}</HashLink> },
		{ Header: 'Shop', accessor: 'SHOP_NAME', width: 100 },
		{ Header: 'Category', accessor: 'CATEGORY_NAME', width: 125 },
		{ Header: 'Part Name', accessor: 'PART_NAME', width: 300 },
		{ Header: 'Alt. Desc', accessor: 'ALT_DESC', width: 125 },
		{ Header: 'Use Unit', accessor: 'UNIT_OF_MEASURE', width: 60 },
		{ Header: 'Recharge Cost', accessor: 'UNIT_COST', width: 80 },
		{ Header: 'Vendor', accessor: 'VENDOR_NAME', width: 125 },
		{ Header: 'Vendor Part #', accessor: 'VENDOR_PART', width: 125 },
		{ Header: 'Vendor Price', accessor: 'VENDOR_PRICE', width: 75 },
		{ Header: 'Vendor Unit', accessor: 'VENDOR_UNIT', width: 75 },
		{ Header: 'Vendor Qty/Unit', accessor: 'VENDOR_UNIT_QTY', width: 75 },
		{ Header: 'Cross Reference', accessor: 'X_REF', width: 125 },
		{ Header: 'Manufacturer Number', accessor: 'MANUF_NUM', width: 125 },
		{ Header: 'Comments', accessor: 'COMMENTS', width: 400 },
		{ Header: 'Inventory', accessor: 'STOCK_QTY', width: 100 }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'PART_ID', width: 12 },
	{ Header: 'Shop', accessor: 'SHOP_NAME', width: 20 },
	{ Header: 'Category', accessor: 'CATEGORY_NAME', width: 25 },
	{ Header: 'Part Name', accessor: 'PART_NAME', width: 60 },
	{ Header: 'Alt. Desc', accessor: 'ALT_DESC', width: 25 },
	{ Header: 'Use Unit', accessor: 'UNIT_OF_MEASURE', width: 12 },
	{ Header: 'Recharge Cost', accessor: 'UNIT_COST', width: 16 },
	{ Header: 'Vendor', accessor: 'VENDOR_NAME', width: 25 },
	{ Header: 'Vendor Part #', accessor: 'VENDOR_PART', width: 25 },
	{ Header: 'Vendor Price', accessor: 'VENDOR_PRICE', width: 15 },
	{ Header: 'Vendor Unit', accessor: 'VENDOR_UNIT', width: 15 },
	{ Header: 'Vendor Qty/Unit', accessor: 'VENDOR_UNIT_QTY', width: 15 },
	{ Header: 'Cross Reference', accessor: 'X_REF', width: 25 },
	{ Header: 'Manufacturer Number', accessor: 'MANUF_NUM', width: 25 },
	{ Header: 'Comments', accessor: 'COMMENTS', width: 80 },
	{ Header: 'Inventory', accessor: 'STOCK_QTY', width: 20 }
];

const newPart = {
	PART_ID: '(new)',
	SHOP_ID: null,
	CATEGORY_ID: null,
	PART_NAME: '',
	ALT_DESC: '',
	UNIT_OF_MEASURE: '',
	UNIT_COST: '',
	VENDOR_NAME: '',
	VENDOR_PART: '',
	VENDOR_PRICE: '',
	VENDOR_UNIT: '',
	VENDOR_UNIT_QTY: '',
	X_REF: '',
	MANUF_NUM: '',
	COMMENTS: '',
	STOCK_QTY: ''
};

const partColumns = [
	{ Header: 'Shop', accessor: 'SHOP_ID', type: 'select', row: 0, col: 0, required: true,
		options: { value: 'SHOP_ID', label: 'SHOP_NAME', entity: 'RECHARGES.PART_SHOP_SELECT_VW', order: 'SHOP_NAME' }},
	{ Header: 'Category', accessor: 'CATEGORY_ID', type: 'select', row: 0, col: 1, required: true,
		options: { value: 'CATEGORY_ID', label: 'CATEGORY_NAME', entity: 'RECHARGES.PART_CATEGORY_SELECT_VW', order: 'CATEGORY_NAME_SORT' }},
	{ Header: 'Part Name', accessor: 'PART_NAME', row: 0, col: 2, required: true },
	{ Header: 'Alt. Desc', accessor: 'ALT_DESC', row: 1, col: 0 },
	{ Header: 'Use Unit', accessor: 'UNIT_OF_MEASURE', row: 1, col: 1, required: true },
	{ Header: 'Recharge Cost $', accessor: 'UNIT_COST', row: 1, col: 2 },
	{ Header: 'Vendor', accessor: 'VENDOR_NAME', row: 2, col: 0, required: true },
	{ Header: 'Vendor Part #', accessor: 'VENDOR_PART', row: 2, col: 1 },
	{ Header: 'Vendor Price', accessor: 'VENDOR_PRICE', row: 2, col: 2, required: true },
	{ Header: 'Vendor Unit', accessor: 'VENDOR_UNIT', row: 3, col: 0, required: true },
	{ Header: 'Vendor Qty/Unit', accessor: 'VENDOR_UNIT_QTY', row: 3, col: 1, required: true },
	{ Header: 'Cross Reference', accessor: 'X_REF', row: 3, col: 2 },
	{ Header: 'Manufacturer Number', accessor: 'MANUF_NUM', row: 4, col: 0 },
	{ Header: 'Comments', accessor: 'COMMENTS', type: 'textarea', row: 4, col: 1 },
	{ Header: 'Inventory', accessor: 'STOCK_QTY', row: 4, col: 2 }
];

export default withRouter(PartsModal);
